// extracted by mini-css-extract-plugin
export var active = "_es-2";
export var recordingDot = "_es-1";
export var recordingIndicator = "_es-0";